import { Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
// import DeleteIcon from "@mui/icons-material/Delete";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { TrackMenuProps } from "../types";
import { TrackMenuContainer } from "../styles";
import { TrackState } from "../../../proto/api_pb";
import { useContext, useEffect } from "react";
import {
  UserDetailsContext,
  UserDetailsContextInterface,
} from "../../../contexts";
import { TrackPrivacySwitch } from "../TrackPrivacySwitch/TrackPrivacySwitch";
import { TEXT_COLOR } from "../../../theme";
import { useTheme } from "@mui/material/styles";

export const TrackMenu: React.FC<TrackMenuProps> = ({
  handleOpenVersionModal,
  id,
  downloadSong,
  handleOpen,
  setIsMasterModalOpen,
  isMasterModalOpen,
  userVerified,
  track,
  trackUrl,
  openDeleteConfirmModal,
  expand,
  handleOpenTrackFileModal,
  setIsPublishModalOpen,
  isTrackPublished,
  setIsTrackPublished,
  hasPaymentMethod,
  handleMasterModalOpen,
  isTrackConnectedToTutorial,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const { connectedWallet } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);

  const handleMinting = (e: any) => {
    e.stopPropagation();
    if (!hasPaymentMethod) {
      navigate("/settings", {
        state: { panel: "hasPaymentMethod" },
      });
    } else if (connectedWallet === "") {
      navigate("/settings", {
        state: { panel: "connectedWallet" },
      });
    } else {
      navigate(`/mint`, {
        state: {
          trackArtist: track?.getArtist(),
          trackUrl: trackUrl,
          trackTitle: track?.getTitle(),
          trackBpm: track?.getBpm(),
          trackKeyNote: track?.getKey()?.getNote(),
          trackKey: track?.getKey()?.getKey(),
          trackKeyScale: track?.getKey()?.getScale(),
          trackGenre: track?.getSongMetadata()?.getGenre(),
          trackDescription: track?.getDescription(),
          trackImageUrl: track?.getImageUrl(),
          trackContributors: track
            ?.getCollaboratorsList()
            .map((collaborators: any) => collaborators.getUsername()),
          trackId: track?.getId(),
        },
      });
    }
  };

  useEffect(() => {
    if (track?.getState() === TrackState.TRACK_STATE_PUBLISHED) {
      setIsTrackPublished(true);
    } else {
      setIsTrackPublished(false);
    }
  }, [setIsTrackPublished, track]);

  return (
    <TrackMenuContainer>
      <span id="track-privacy-switch">
        <TrackPrivacySwitch
          isTrackPublished={isTrackPublished}
          isTrackConnectedToTutorial={isTrackConnectedToTutorial}
          setIsPublishModalOpen={setIsPublishModalOpen}
          track={track}
          setIsTrackPublished={setIsTrackPublished}
        />
      </span>
      <Tooltip title="Add Version">
        <span>
          <IconButton
            id={isTrackConnectedToTutorial ? "step-13" : ""}
            sx={{ color: TEXT_COLOR, zIndex: 1000 }}
            aria-label="add-version"
            onClickCapture={(e) => {
              if (handleOpenVersionModal) {
                e.stopPropagation();
                handleOpenVersionModal(id!);
              }
            }}
          >
            <AddIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Add File">
        <span>
          <IconButton
            id={isTrackConnectedToTutorial ? "step-14" : ""}
            sx={{ color: TEXT_COLOR, zIndex: 1000 }}
            aria-label="add-file"
            onClickCapture={(e) => {
              if (handleOpenTrackFileModal) {
                e.stopPropagation();
                handleOpenTrackFileModal(id!);
              }
            }}
          >
            <NoteAddIcon sx={{ fontSize: 25 }} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Download Current Version">
        <span>
          <IconButton
            id={isTrackConnectedToTutorial ? "step-15" : ""}
            sx={{ color: TEXT_COLOR, zIndex: 1000 }}
            aria-label="download"
            onClickCapture={(e) => {
              e.stopPropagation();
              downloadSong();
            }}
          >
            <DownloadIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Edit">
        <span>
          <IconButton
            id={isTrackConnectedToTutorial ? "step-16" : ""}
            sx={{ color: TEXT_COLOR, zIndex: 1000 }}
            aria-label="edit"
            onClickCapture={(e) => {
              e.stopPropagation();
              handleOpen(id!);
            }}
          >
            <EditIcon />
          </IconButton>
        </span>
      </Tooltip>
      {
        <Tooltip title="Master">
          <span>
            <IconButton
              id={isTrackConnectedToTutorial ? "step-17" : ""}
              sx={{ color: "white", zIndex: 1000, marginRight: 1 }}
              aria-label="master"
              onClickCapture={(e) => {
                e.stopPropagation();
                handleMasterModalOpen();
              }}
            >
              <img
                style={
                  theme.palette.mode === "light"
                    ? { backgroundColor: "black" }
                    : {}
                }
                height="24px"
                width="24px"
                src={`/assets/svg/dolby.svg`}
                alt=""
              />
            </IconButton>
          </span>
        </Tooltip>
      }
      {userVerified && (
        <Tooltip title="Mint">
          <span>
            <IconButton
              id={isTrackConnectedToTutorial ? "step-18" : ""}
              sx={{ zIndex: 1000, marginLeft: -1 }}
              aria-label="master"
              onClickCapture={(e) => handleMinting(e)}
            >
              <img
                style={
                  theme.palette.mode === "light"
                    ? { backgroundColor: "black" }
                    : {}
                }
                height="24px"
                width="24px"
                src={`/assets/images/ethereum.svg`}
                alt=""
              />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {/* <Tooltip title="Delete">
        <IconButton
          sx={{ color: "white", zIndex: 1000 }}
          aria-label="delete"
          onClickCapture={(e) => {
            e.stopPropagation();
            openDeleteConfirmModal!(id!);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip> */}
      {expand ? (
        <Tooltip title="Minimize">
          <IconButton
            onClickCapture={() => navigate(-1)}
            sx={{ color: TEXT_COLOR }}
          >
            <FullscreenExitIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Open Track Page">
          <IconButton
            onClickCapture={(e) => {
              e.stopPropagation();
              navigate(`/track/${id}`, { state: { id: id } });
            }}
            sx={{ color: TEXT_COLOR, zIndex: 1000, marginLeft: -1 }}
          >
            <FullscreenIcon />
          </IconButton>
        </Tooltip>
      )}
    </TrackMenuContainer>
  );
};
